// @ constants
const actionTypes = require('constants/actionTypes');
const {
    COLLECTIVE_PRODUCT_LIST_URL_PARAM,
    CREDIT_CARD_SUBTYPE_DIAMOND,
    CREDIT_CARD_SUBTYPE_PREMIUM,
    CREDIT_CARD_TYPE_PACK,
    DEBIT_CARD_SUBTYPE_DIAMOND,
    DEBIT_CARD_SUBTYPE_PREMIUM,
    DEBIT_CARD_TYPE,
    DIAMOND_PACK_HIRING,
    PREMIUM_PACK_HIRING
} = require('constants/index');

//@ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const { getCollectivesCardContent } = require('actions/collectivesCardContent');

const getCollectivesProductListRequest = () => ({
    type: actionTypes.COLLECTIVE_PRODUCT_LIST_REQUEST
});

const getCollectivesProductListSuccess = (response) => ({
    type: actionTypes.COLLECTIVE_PRODUCT_LIST_SUCCESS,
    payload: {
        response
    }
});

const getCollectivesProductListFailure = (error) => ({
    type: actionTypes.COLLECTIVE_PRODUCT_LIST_FAILURE,
    payload: {
        error
    }
});

const getCollectivesProductList = () => (dispatch, getState) => {
    dispatch(getCollectivesProductListRequest());
    const params = {
        query: {
            'uiComponent': COLLECTIVE_PRODUCT_LIST_URL_PARAM
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'requestCollectivesProductList',
        params
    })
        .then(response => {
            dispatch(getCollectivesProductListSuccess(response));

            const flagBasedFeatures = getState().flagBasedFeatures;
            const collectivesDiamondPackEnabled = flagBasedFeatures.get('collectives-diamond-pack-enabled');
            const collectivesPremiumPackEnabled = flagBasedFeatures.get('collectives-premium-pack-enabled');

            const collectivesProductList = getState().collectivesProductList;
            const productList = collectivesProductList.get('productList');

            //Call the proposition API to get the cms content for Diamond pack
            if(collectivesDiamondPackEnabled) {
                //Check if the document ids matches with type and subtype
                const isDiamondPack = productList && productList.find((product) => {
                    let type = product.get('productType');
                    let subType = product.get('productSubtype');
                    if ( (type === CREDIT_CARD_TYPE_PACK && subType === CREDIT_CARD_SUBTYPE_DIAMOND) ||
                        (type === DEBIT_CARD_TYPE && subType === DEBIT_CARD_SUBTYPE_DIAMOND)
                    )
                        return product;
                });
                if (!!isDiamondPack) {
                    dispatch(getCollectivesCardContent(DIAMOND_PACK_HIRING));
                }
            }

            if(collectivesPremiumPackEnabled) {
                //Check if the document ids matches with type and subtype
                const isPremiumPack = productList && productList.find((product) => {
                    let type = product.get('productType');
                    let subType = product.get('productSubtype');
                    if ( (type === CREDIT_CARD_TYPE_PACK && subType === CREDIT_CARD_SUBTYPE_PREMIUM) ||
                        (type === DEBIT_CARD_TYPE && subType === DEBIT_CARD_SUBTYPE_PREMIUM)
                    )
                        return product;
                });
                if (!!isPremiumPack) {
                    dispatch(getCollectivesCardContent(PREMIUM_PACK_HIRING));
                }
            }
        })
        .catch(response => {
            dispatch(getCollectivesProductListFailure(response));
        });
};

module.exports = getCollectivesProductList
